import React from 'react';
import { RiStackLine, RiTeamLine, RiFlowChart } from 'react-icons/ri';
import ContactContent from './ContactContent';
import BYOEContent from './BYOEContent';
import OaaSFlowDiagram from './diagrams/OaaSFlowDiagram';

const WhatIsStackformContent = ({ contact, setContact, handleContactSubmit, contactStatus }) => {

  const modeCardStyle = {
    padding: '0.85rem 1rem',
    border: '1px solid var(--border-color, #ddd)',
    borderRadius: '8px',
    marginBottom: '0.75rem',
  };

  return (
    <div style={{ marginTop: "1rem", lineHeight: "1.5", fontSize: "0.9rem" }}>
      <p style={{ fontSize: "1.05rem" }}>
        <strong>One platform. Three ways to work with AI.</strong>
      </p>
      <p>
        Stackform puts a coordinated team of specialized AI agents at your
        fingertips. Choose the mode that fits your task — from instant
        research synthesis to live multi-agent debate to fully custom
        pipelines you build yourself.
      </p>

      {/* ── Three modes ─────────────────────────────────────────── */}
      <div style={{ margin: '1.25rem 0' }}>

        <div style={{ ...modeCardStyle, borderLeft: '3px solid var(--primary-color, #636cff)' }}>
          <strong style={{ display: 'flex', alignItems: 'center', gap: 7, color: 'var(--primary-color, #636cff)', marginBottom: '0.35rem' }}>
            <RiStackLine size={16} /> Ask — Orchestrated Research
          </strong>
          <p style={{ margin: 0 }}>
            The default mode. Stackform's <strong>Orchestrator</strong> answers
            immediately from its own knowledge, then silently dispatches
            specialist agents — <strong>Generalist</strong> (web &amp; news),{' '}
            <strong>Researcher</strong> (academic literature) — and synthesizes
            a final, comprehensive report. Best for research questions,
            factual queries, and anything that benefits from multiple sources.
          </p>
        </div>

        <div style={{ ...modeCardStyle, borderLeft: '3px solid var(--success-color, #28a745)' }}>
          <strong style={{ display: 'flex', alignItems: 'center', gap: 7, color: 'var(--success-color, #28a745)', marginBottom: '0.35rem' }}>
            <RiTeamLine size={16} /> Swarm — Live Multi-Agent Debate
          </strong>
          <p style={{ margin: 0 }}>
            Multiple AI agents take turns debating your topic in real time.
            You stay in the loop — <strong>intervene</strong> mid-debate,{' '}
            <strong>pause</strong> to reflect, adjust pacing, and request a{' '}
            <strong>summary</strong> at any point. Best for brainstorming,
            exploring competing perspectives, and open-ended discovery where
            the conversation itself is the value.
          </p>
        </div>

        <div style={{ ...modeCardStyle, borderLeft: '3px solid #f59e0b' }}>
          <strong style={{ display: 'flex', alignItems: 'center', gap: 7, color: '#f59e0b', marginBottom: '0.35rem' }}>
            <RiFlowChart size={16} /> Workflows — Visual Pipelines
          </strong>
          <p style={{ margin: 0 }}>
            Build reusable, multi-step AI pipelines with a drag-and-drop
            canvas. Chain Input, Agent, Tool, Logic, and Output nodes into any
            sequence you need — then run them with a single click from the
            chat panel and watch live, per-agent progress as each node runs.
            Five platform workflows are built in; the{' '}
            <strong>Workflow Builder</strong> lets you create unlimited custom
            ones. Best for recurring research tasks, structured analysis, and
            any process you want to define once and repeat reliably.
          </p>
        </div>
      </div>

      <p>
        Stackform also supports <strong>Bring Your Own Endpoints and Models
        (BYOE)</strong>: connect your own OpenAI, Gemini, Anthropic, Azure, or
        AWS keys — or run agents on local models from your own device — so
        every agent runs on models you control and trust.
      </p>

      <p style={{ fontSize: "0.8rem", color: "var(--text-secondary, #888)", fontStyle: "italic" }}>
        The name combines <em>Stack</em> — the composable layer of specialized
        agents you configure — with <em>Form</em> — the coordinated shape they
        take when assembled around your question. Every query forms a different
        team; every team is your stack.
      </p>

      <OaaSFlowDiagram />
      <hr />
      <BYOEContent />

      <div id="contact-section" style={{ marginTop: "2rem", borderTop: "1px solid var(--border-color, #ccc)", paddingTop: "1rem" }}>
        <h2>Contact Us</h2>
        <p style={{ marginBottom: "1rem", color: "var(--text-secondary, #666)" }}>
          Questions, feedback, or feature requests? We read everything.
        </p>
        <ContactContent
          contact={contact}
          setContact={setContact}
          handleContactSubmit={handleContactSubmit}
          contactStatus={contactStatus}
        />
      </div>
    </div>
  );
};

export default WhatIsStackformContent;
